import React, { useContext } from 'react';
import { CmsContext } from '../context/CmsContext';
import { CommonPage } from '../components/common/CommonPage';


export const WhatWeDo = () => {
  const { cmsData, loading } = useContext(CmsContext);

  return (
    <CommonPage
      pageTitle="What We Do"
      ckData={cmsData?.whatWeDo}
      loading={loading}
    />
  );
};
